<template>

    <div class="notice-manage-box">
        <div class="notice-manage-top-box">
            <div class="notice-add-user-button">
                <el-button size="mini" style="border-radius: 4px" type="primary" @click="addNoticeUsers()">添加用户
                </el-button>
            </div>
        </div>
        <div class="notice-table-box">
            <flex>
                <el-table
                        :data="list.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                        height="100%" width="100%"
                        size="small" :header-row-style="{color:'black'}" stripe>
                    <el-table-column
                            type="index"
                            label="序号"
                            :index="indexMethod"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="用户编码"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="realName"
                            label="用户名称"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="contactPerson"
                            label="联系人"
                            align="center"
                            :formatter="contentFormat">
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="手机"
                            align="center"
                            :formatter="contentFormat">
                    </el-table-column>
                </el-table>
            </flex>


            <!--</div>-->
            <div class="notice-page-box">

                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="list.length"
                        style="font-size:small;">
                </el-pagination>
            </div>
        </div>
        <div class="notice-manage-down-box">
            <div class="notice-template-box">
                <div style="text-align: left;color:#00A5B2 ;font-size: 1.3rem;padding-top: 1rem;padding-bottom: 0.3rem">
                    请选择通知模板
                </div>
                <!--注意radio2-->
                <div class="template-choose-box" style="height: 1.6rem;overflow-y: scroll;overflow-x: hidden"
                     v-if="radio2==null || radio2!='' || radio2==undefined">
                    <el-radio-group v-model="radio2">
                        <el-radio style="font-size: 1rem" v-for="item in templateList2" :label="item" :key="item.id">{{
                            item.name }}
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="template-choose-box" style="height: 1.6rem;overflow-y: scroll;overflow-x: hidden"
                     v-if="radio2===null || radio2==='' || radio2===undefined">
                    <span style="font-size: 1rem">无通知模板选择!</span>
                </div>
            </div>
            <div class="notice-write-box">
                <div style="text-align: left;color:#00A5B2;font-size: 1.3rem;padding-top: 0.8rem;padding-bottom: 0.3rem">
                    通知填写
                </div>
                <div style="text-align: left;height: 3.6rem;">
                    <!--<p style="text-align: left" v-html="emptyOut(radio2.smsTemplateContent)"> </p>-->
                    <!--<p class="p1" style="text-align: left;font-size: 1rem" v-html="$options.filters.value(radio2.smsTemplateContent)"> </p>-->
                    <div id="p1" style="text-align: left;font-size: 1rem"
                         v-html="radio2.content==null || radio2.content=='' || radio2.content==undefined ? '无模板内容！':'【'+radio2.signature+'】'+radio2.content "></div>
                </div>
                <p style="text-align: left;font-size: 1rem">说明：为避免被网络误认为是垃圾短信，通知内容格式需要按照模板填写，字数限制在200字以内；预计当前短信内容计费<span
                        style="background-color: #009bac;border-radius:10%;color: white"> {{contentLength>70? contentLength%67>0 ? parseInt(contentLength/67)+1:parseInt(contentLength/67):1}} </span>条。
                </p>
            </div>
            <div class="notice-send-box" style="text-align: left">
                <el-button size="mini" type="primary" @click="sendNotice">发送</el-button>
            </div>
        </div>
        <el-dialog
                width="24rem"
                :visible.sync="treeVisible"
                align="left"
                top="15vh"
                title="选择通知用户"
        >


            <el-tree
                    v-loading="loading"
                    :data="energyUnitTree"
                    show-checkbox
                    node-key="id"
                    default-expand-all
                    ref="tree"
                    :props="defaultProps"
                    :default-expanded-keys="expandedKeys"
                    :default-expand-all="false"
                    style="padding-left: 15px;"
            >
            </el-tree>
            <div class="dialog-footer" style="text-align: right;border-top: 1px solid #dedede;">
                <el-button type="primary" @click="getNoticeUser" size="small"
                           style="margin-right: 2rem;margin-bottom: 1rem;margin-top: 1rem">确定
                </el-button>
            </div>

        </el-dialog>
        <el-dialog
                class="sendSms"
                top="15vh"
                title="短信发送"
                :visible.sync="sendTableVisible"
                align="left" @close='closeDialog'>
            <div class="center-box" v-if="hidden" style="height: 9rem">
                <!--<i class="el-icon-loading" ></i>-->
                <svg-icon icon-class="等待" style="height:5rem;width: 5rem;"></svg-icon>
                <p>正在发送，请稍候. . .</p>
            </div>
            <div class="center-box" v-if="!hidden" style="height: 9rem">
                <img src="~@/assets/sms-send-success.png" style="width: 20%;height: 5rem"/>
                <div>
                    <div style="text-align: left;width: 89px;margin: 0 auto">
                        <p style="font-weight:bold;color: #00A5B2">已成功发送 {{sendSuccessNumber}} 条</p>
                        <p>失败 {{sendFailureNumber}}条</p>
                    </div>
                </div>
            </div>
            <div style="margin-left: 2rem;margin-right: 2rem">
                <span style="color: black;font-weight:bold ">失败记录</span>
                <div class="notice-table2-box">
                    <flex>
                        <el-table
                                :data="resultsList2.slice((currentPage2-1)*pagesize2,currentPage2*pagesize2)"
                                border
                                stripe
                                height="100%" width="100%" size="mini" :header-row-style="{color:'black'}">
                            <el-table-column
                                    type="index"
                                    label="序号"
                                    :index="indexMethod2"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    label="用户编码"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="realName"
                                    label="用户名称"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="contactPerson"
                                    label="联系人"
                                    align="center"
                                    :formatter="contentFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="mobile"
                                    label="手机"
                                    align="center"
                                    :formatter="contentFormat">
                            </el-table-column>
                        </el-table>
                    </flex>
                </div>
                <div class="notice-page-box">
                    <el-pagination
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="currentPage2"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            :page-size="1"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="resultsList2.length">
                    </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: left">
                        <el-button type="primary" @click="toResendSms" style="margin-right: 2rem;" size="small"
                                   :disabled=" hidden ? true : false">重新发送</el-button>
                    </span>
        </el-dialog>
    </div>


</template>

<script>
  import {mapGetters} from 'vuex'
  import {queryCustomerByEnergyUnitIds} from '@/api/customerUser'
  import {queryTemplate, sendBatchSms} from '@/api/smsPlatform'
  import {tree, expandedCustomer} from '@/utils/energyUtilTree'
  import Flex from '@/components/Flex'

  var that = {}
  export default {
    name: "NoticeManage",
    components: {
      'flex': Flex
    },
    data() {
      return {
        hidden: true,
        list: [],//用户列表
        resultsList2: [],//短信发送后返回的结果行
        resultsList3: [],//临时存放短信发送后返回的结果行
        currentPage: 1,//默认第一页
        pagesize: 10,//默认显示多少条
        currentPage2: 1,//默认第一页
        pagesize2: 10,//默认显示多少条
        templateList2: [
          // {smsTemplateId:null,smsTemplateContent:null,smsTemplateParam:null,smsTemplateType:null}
        ],//模板列表值
        radio2: '', // 这个就是你要选中的值
        noticeTontext: '',
        treeVisible: false,
        loading: false,
        energyUnitTree: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        sendTableVisible: false,
        sendSuccessNumber: 0,
        sendFailureNumber: 0,
        param: '',
        contentInitLength: 0,//短信没有填写时初始长度
        contentLength: 0,//短信编写后的长度
        expandedKeys: []
      }
    },
    beforeCreate() {
      that = this;
    },
    computed: {
      ...mapGetters([
        'customerId'
      ]),

    },
    watch: {
      radio2: function () {
        this.$nextTick(function () {
          /*现在数据已经渲染完毕,计算短信字数和添加文本框值改变事件*/
          this.addEvent()
        })
      },
    },
    mounted() {
      //查询通知短信模板的信息
      this.fetchTemplate()
    },
    methods: {
      fetchTemplate() { // 查询通知模板，并动态生成
        queryTemplate(this.customerId, '通知').then(res => {
          if (res.code === 200) {
            this.templateList2 = res.infoJson
            for (let i = 0; i < this.templateList2.length; i++) {
              this.templateList2[i]
              const param = this.templateList2[i].param
              if (param !== "" && param !== null && param !== undefined) {
                const paramArr = param.split("&&")
                for (let j = 0; j < paramArr.length; j++) {
                  this.templateList2[i].content = this.templateList2[i].content.replace("${" + paramArr[j] + "}", '&nbsp;<textarea class="emptyOut" style="vertical-align:text-top;font-size: 1rem;resize: none;border:0.1rem solid #d1dbde;outline:none;"></textarea>&nbsp;')
                }
              }
            }
            //默认选中第一个
            if (this.templateList2.length > 0) {
              this.radio2 = this.templateList2[0]
            }
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '短信模板查询失败'
          })
        })
      },
      addNoticeUsers() {
        this.treeVisible = true;
        //获取用能单位的用户，树状数据
        this.selectEnergyUnit();
      },
      //获取选中的用户信息
      getNoticeUser: function () {
        this.hidden = true;
        this.list = [];
        const nodesArr = this.$refs.tree.getCheckedNodes();
        const idArr = [];
        for (let i = 0; i < nodesArr.length; i++) {
          if (nodesArr[i].type == 1) {
            idArr.push(nodesArr[i].id);
          }
        }
        if (idArr.length > 0) {
          //根据选择的用户id获取用户信息
          queryCustomerByEnergyUnitIds(idArr).then(res => {
            if (res.code === 200) {
              this.list = res.infoJson
            }
          }).catch(error => {
          })
          this.treeVisible = false;
        } else {
          this.$message({
            message: '请选择至少选择一个用户',
            type: 'warning'
          })
        }
      },
      toResendSms() {
        if (this.resultsList2.length <= 0) {
          this.$message({
            message: '用户短信通知全部发送成功！',
            type: 'warning'
          });
          return;
        }
        this.hidden = true;
        // 组装发送条件
        const smsSendInfo = this.sendSmsParam(this.resultsList2, this.param)
        this.resultsList3 = this.resultsList2
        this.resultsList2 = []
        sendBatchSms(smsSendInfo).then(res => {
          if (res.code === 200) {
            // 返回发送失败的用户信息
            const userList = res.infoJson
            //前台循环选择的用户信息list和发送返回的用户信息resultsList2,来判断和查找失败的用户信息
            if (userList.length > 0) {
              for (let i = 0; i < userList.length; i++) {
                for (let j = 0; j < this.list.length; j++) {
                  if (userList[i].userId == this.list[j].id) {
                    this.resultsList2.push(this.list[j])
                  }
                }
              }
            }
            this.sendSuccessNumber = res.message;
            this.sendFailureNumber = userList.length;
          } else {
            this.resultsList2 = this.resultsList3
            this.sendFailureNumber = this.resultsList2.length;
          }
          this.hidden = false;
        }).catch(error => {
          this.hidden = false;
          this.resultsList2 = this.resultsList3
          this.sendFailureNumber = this.resultsList2.length;
        })
      },
      //查询建筑区域所有的客户用户
      selectEnergyUnit() {  //查询能耗单元树
        this.loading = true;
        const customerId = this.customerId;
        const id = [];
        tree(customerId, null, 2, null, 1).then(response => {
          this.energyUnitTree = response[0].children
          this.expandedKeys.push(expandedCustomer(response))
          this.loading = false
        }).catch(error => {
          this.loading = false
        })
      },
      contentFormat(row, column, cellValue) {   //表格中内容格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== "") {
          return cellValue
        }
        return "--"
      },
      handleSizeChange: function (size) {
        this.pagesize = size
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
      },
      handleSizeChange2: function (size) {
        this.pagesize2 = size
      },
      handleCurrentChange2: function (currentPage) {
        this.currentPage2 = currentPage
      },
      addEvent: function () {
        //获取通知短信内容的字数，加上了【】
        this.contentInitLength = document.getElementById("p1").innerText.length;
        const emptyOutClass = document.getElementsByClassName("emptyOut");
        if (document.getElementsByTagName("textarea").length > 0) {
          for (let i = 0; i < emptyOutClass.length; i++) {
            //文本框的前后加上了空格，减去
            this.contentInitLength = this.contentInitLength - 2
            //给文本框添加事件
            emptyOutClass[i].addEventListener('input', function () {
              this.value = this.value.replace(/\&/g, '')//"&"这个字符是用来拼接参数，所以不能使用
              // console.log(this.value);//依然是这个方法的对象

              // console.log(that) //这个变成了原来的对象
              const emptyOutClassArr = document.getElementsByClassName("emptyOut");
              let a = 0
              for (let i = 0; i < emptyOutClassArr.length; i++) {
                a += emptyOutClassArr[i].value.length
              }
              that.contentLength = a + that.contentInitLength
            })
          }
          this.contentLength = this.contentInitLength
          // console.log(this);//依然是这个方法的对象
        }
      },
      //发送通知
      sendNotice() {
        if (this.list.length <= 0) {
          this.$message({
            message: '未选择添加要发送短信通知的用户',
            type: 'warning'
          });
          return;
        }
        //获取输入的参数值，拼接param
        const emptyOutClass = document.getElementsByClassName("emptyOut");
        if (document.getElementsByTagName("textarea").length > 0) {
          //用于判断通知模板内容是都均未填写
          let isnull = true;
          for (let i = 0; i < emptyOutClass.length; i++) {
            if (isnull == true) {
              if (emptyOutClass[i].value == '') {
                isnull = true
              } else {
                isnull = false
              }
            }
            this.param += emptyOutClass[i].value + "&&"
            this.contentLength += emptyOutClass[i].value.length
          }
          if (isnull) {
            this.param = ""
            this.$message({
              message: '短信通知模板内容未填写',
              type: 'warning'
            });
            return;
          }
          if (this.contentLength > 200) {
            this.param = ''
            this.$message({
              message: '短信通知模板内容过长（200以内）！',
              type: 'warning'
            });
            return;
          }
          this.param = this.param.substring(0, this.param.lastIndexOf("&&"));
        }
        this.sendTableVisible = true
        // 组装发送条件
        const smsSendInfo = this.sendSmsParam(this.list, this.param)
        sendBatchSms(smsSendInfo).then(res => {
          if (res.code === 200) {
            // 返回发送失败的用户信息
            const userList = res.infoJson
            // 前台循环选择的用户信息list和发送返回的用户信息resultsList2,来判断和查找失败的用户信息
            if (userList.length > 0) {
              for (let i = 0; i < userList.length; i++) {
                for (let j = 0; j < this.list.length; j++) {
                  if (userList[i].userId == this.list[j].id) {
                    this.resultsList2.push(this.list[j])
                  }
                }
              }
            }
            this.sendSuccessNumber = res.message;
            this.sendFailureNumber = userList.length;
          } else {
            this.resultsList2 = this.list
            this.sendFailureNumber = this.resultsList2.length;
          }
          this.hidden = false;
        }).catch(error => {
          this.hidden = false;
          this.resultsList2 = this.list
          this.sendFailureNumber = this.resultsList2.length;
        })
      },
      /**
       * 组装发送条件
       * @param uesrs
       * @param param
       */
      sendSmsParam(uesrs, param) {
        const templateCode = this.radio2.code;
        const result = {}
        const smsSendInfo = []
        for (let i = 0; i < uesrs.length; i++) {
          let smsSendParam = {}
          smsSendParam.userId = uesrs[i].id
          smsSendParam.phone = uesrs[i].mobile
          smsSendParam.templateCode = templateCode
          smsSendParam.templateParam = param
          smsSendInfo.push(smsSendParam);
        }
        result['customerId'] = this.customerId
        result['smsList'] = smsSendInfo
        return result;
      },
      closeDialog() {
        this.list = [];
        this.resultsList2 = [];
        this.contentLength = this.contentInitLength
        //获取输入的参数值
        const emptyOutClass = document.getElementsByClassName("emptyOut");
        for (let i = 0; i < emptyOutClass.length; i++) {
          emptyOutClass[i].value = ''
        }
        this.param = ''
      },
      indexMethod(index) {
        return (this.currentPage - 1) * this.pagesize + index + 1
      },
      indexMethod2(index) {
        return (this.currentPage2 - 1) * this.pagesize2 + index + 1
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .notice-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .notice-add-user-button {
            height: 20%;
            margin-top: 10px;
            text-align: left;
            margin-left: 30px;
            margin-bottom: 10px;
        }
        .notice-table-box {
            flex-direction: column;
            height: calc(52vh - 3.3rem);
            width: 100%;
            border-bottom: 1px solid #dedede;
            display: flex;

        }
        .notice-table2-box {
            margin-top: 10px;
            flex: 1;
            height: 16rem;
            flex-direction: column;
        }
        .template-choose-box {
            text-align: left;
            /*margin-left: 30px;*/

        }

        .center-box {
            /*height:20rem ;*/
            text-align: center;
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center; /* 水平居中 */
            align-items: center; /* 垂直居中 */
        }

        p {
            margin: 0.5rem auto;
        }
        .notice-manage-top-box {
            width: 100%;
            height: 3.3rem;
            margin-top: 5px;
            background-color: #ffffff;
            border: 0px;
            //margin-bottom: 10px;
        }
        .notice-manage-down-box {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 29vh;
            background-color: #ffffff;
            /*overflow: scroll;*/
        }

        .div-hr {
            height: 1px;
            background-color: #dedede;
        }
        .notice-template-box {

            margin-left: 30px;
        }
        .notice-write-box {

            margin-left: 30px;
        }
        .notice-send-box {
            margin-top: 3px;
            margin-left: 30px;
        }

        .notice-page-box {
            display: flex;
            height: 2rem;
            justify-content: center;
            flex-direction: row;
            background-color: #ffffff;
        }

    }


</style>
<style>

    .el-table th {
        background-color: #f5fafb;
    }

    .notice-write-box textarea {
        background-color: #f5fafb;
        height: 2rem;
        width: 15rem;
    }

    .notice-manage-box .el-dialog__body {
        border-top: 1px solid #dedede;
        padding: 0rem 0rem 0rem 0rem;
        background: #f6f7f7;
        /*font-size: 14px;*/
    }

    .notice-manage-box .el-dialog__footer {

        padding: 0.625rem 0rem 1.25rem;
    }

    /*.notice-manage-box .el-dialog{*/
    /*max-height:calc(100% - 25vh);*/
    /*!*max-width: calc(100% - 94vh);*!*/
    /*display: flex;*/
    /*flex-direction: column;*/
    /*overflow: auto;*/
    /*}*/
    .notice-manage-box .el-tree {
        display: flex;
        overflow: auto;
        max-height: 55vh;
        background: #f6f7f7;
    }

    .notice-manage-box .el-dialog {
        background: #f6f7f7;
    }

    .notice-manage-box .el-dialog > .el-dialog__body {
        overflow: auto;
        background: #f6f7f7
    }

    .el-table::before {
        height: 0px;
    }

    .el-table th {
        /*background-color: #abffeb;*/
    }

    .notice-manage-box button {
        font-weight: bold
    }
</style>
